module.exports = __webpack_public_path__ + "img/049-indecisive.b15830e9.png";